module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gw-f647ba54d53db3f2e3a46a66bb84f3c7.svg";